import { USER_TYPE } from '@/utils/constants';
import { confirmEnterprise } from '@/services/api/enterprise';
import { mapActions, mapState } from 'vuex';
import { dateFilter } from '@/utils/filters';
import { currencyFilter } from '@/utils/filters';
import InsufficientFunds from '@/components/supplier/enterprise/modal/insufficient-funds.vue'

export default {
    components: { InsufficientFunds },
    props: {
        isMobile: [Boolean, Object],
        competition: {
            type: Object,
            default: () => { }
        }
    },
    data() {
        return {
            loading: false,
            loadingConfirm: false,
            showModal: false
        };
    },
    methods: {
        currencyFilter,
        ...mapActions('sweetalert2', ['showAlert']),
        ...mapActions('notification', ['showNotification']),
        ...mapActions('user', ['setSubscriptionHeader']),
        dateFilter,
        openLink(link) {
            window.open(link, '_blank');
        },
        async confirmNotInteresting() {
            const result = await this.$swal({
                title: 'Deseja recusar esta oportunidade?',
                text:
                    'Não deixe de verificar o seu email, você será notificado sobre o status do agendamento através dele!',
                icon: 'error',
                reverseButtons: true,
                showConfirmButton: true,
                showCancelButton: true,
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não',
                showCloseButton: true
            });
            if (result && result.isConfirmed) {
                await this.postVisit('not_accept');
                this.redirectToListQuotation();
            }
        },
        redirectToListQuotation() {
            this.$router.push({ name: 'CompetitionDashboard' });
        },
        redirectToListOpportunities() {
            this.$router.push({ name: 'MyOpportunities' });
        },
        async postVisit(type) {
            // type: accept/ or not_accept
            try {
                await confirmEnterprise(this.competition.id, type);
            } catch (error) {
                console.error(error);
                this.showNotification({ text: error.status, type: 'error' });
            }
        },
        async createVisit() {
            if (this.competition.nextSlot.price > this.coins && this.competition.nextSlot.price > this.bonus) {
                this.showModal = true
            } else {
                this.loadingConfirm = true;
                await this.postVisit('accept');
                const result = await this.$swal({
                    title: 'Solicitação confirmada!',
                    text:
                        'Não deixe de verificar o seu email, você será notificadosobre o status do agendamento através dele!',
                    icon: 'success',
                    allowOutsideClick: false
                });
                if (result && result.isConfirmed) {
                    this.setSubscriptionHeader();
                    this.redirectToListOpportunities();
                }
            }
        },
        goToCoinPack() {
            this.$router.push({ name: 'BalancePurchase' })
        }
    },
    computed: {
        ...mapState('user', ['supplierData']),
        coins() {
            return this.supplierData.coins.replace(/\./g, '').replace(/\,/g, '.') // eslint-disable-line
        },
        bonus() {
            return this.supplierData.bonus.replace().replace(/\./g, '').replace(/\,/g, '.') // eslint-disable-line
        },
        publicOrganizationLink() {
            const array = [];
            if (this.competition.publicOrganizationLink.length && this.competition.hasOccupation)
                array.push(this.competition.publicOrganizationLink);
            return array;
        },
        links() {
            const array = this.competition.links.links;
            return array;
        },
        iconTitle() {
            const obj = {
                'Construção civil': 'hard-hat.svg',
                contractor_type: 'hard-hat.svg',
                'Cliente Engelink': 'house.svg',
                'Pessoa Física': 'house.svg',
                Corporativo: 'business.svg',
                Condomínio: 'building.svg',
                Solicitante: 'building.svg',
                Administradora: 'building.svg',
                'Síndico(a) profissional': 'building.svg'
            };
            return require('@/assets/images/' + obj[this.competition.contractorTypeValue]);
        },
        contractorType() {
            if (
                this.competition.contractorTypeKey === USER_TYPE.REQUESTER ||
                this.competition.contractorTypeKey === USER_TYPE.CONDO_ADMINISTRATOR ||
                this.competition.contractorTypeKey === USER_TYPE.PROFESSIONAL_BUILDING_MANAGER
            ) {
                return 'Condomínio';
            } else if (this.competition.contractorTypeKey === USER_TYPE.PRIVATE_PERSON) {
                return 'Cliente Engelink';
            } else {
                return this.competition.contractorTypeValue;
            }
        },
        cssVars() {
            return {
                '--mask-src': 'url(' + this.iconTitle + ')'
            };
        },
        statusCompetition() {
            return !!this.competition.meetingData && !!this.competition.meetingData.status == 3;
        },
        statusText() {
            if (this.competition.meetingData.status == 1) {
                return 'Ainda estamos em contato com o contratante, logo lhe daremos um retorno sobre o agendamento da visita.';
            } else if (this.competition.meetingData.status == 3)
                return `Agendamento rescusado. ${this.competition.meetingData.schedulingInformation}`;
            else {
                return this.competition.meetingData.schedulingInformation;
            }
        }
    }
};
